import { render, staticRenderFns } from "./haiBoTangPage.vue?vue&type=template&id=87e0996e&scoped=true"
import script from "./haiBoTangPage.vue?vue&type=script&lang=js"
export * from "./haiBoTangPage.vue?vue&type=script&lang=js"
import style0 from "./haiBoTangPage.vue?vue&type=style&index=0&id=87e0996e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e0996e",
  null
  
)

export default component.exports